import { render, staticRenderFns } from "./BaseIcon.vue?vue&type=template&id=06a6a8b7&"
import script from "./BaseIcon.vue?vue&type=script&lang=js&"
export * from "./BaseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports